import {
  isEchoesConsentRequiredAtom,
  isProfileCompleteAtom,
  isSessionValidAtom,
  sessionErrorAtom,
  sessionLoadingAtom,
  sessionUserAtom,
} from "@src/store/session"
import { useAtomValue } from "jotai"
import { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { GlobalNav } from "@/components/layouts/global-nav"
import { Spinner } from "@/components/ui/spinner/Spinner"

export function MainLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const sessionUser = useAtomValue(sessionUserAtom)
  const isLoading = useAtomValue(sessionLoadingAtom)
  const error = useAtomValue(sessionErrorAtom)
  const isSessionValid = useAtomValue(isSessionValidAtom)
  const isProfileComplete = useAtomValue(isProfileCompleteAtom)
  const isEchoesConsentRequired = useAtomValue(isEchoesConsentRequiredAtom)

  useEffect(() => {
    if (error) {
      toast.error(error.message || "セッション情報の取得に失敗しました。", {
        id: "session-error",
      })
    }
  }, [error])

  useEffect(() => {
    if (
      isSessionValid &&
      sessionUser &&
      isEchoesConsentRequired &&
      location.pathname !== "/echoes/consent"
    ) {
      navigate("/echoes/consent")
    }
  }, [isSessionValid, sessionUser, isEchoesConsentRequired, location.pathname, navigate])

  useEffect(() => {
    if (
      isSessionValid &&
      sessionUser &&
      !isEchoesConsentRequired &&
      !isProfileComplete &&
      location.pathname !== "/profile/complete"
    ) {
      toast.info("サービスをご利用いただくために、プロフィール情報の登録をお願いします。", {
        id: "profile-incomplete",
      })
      navigate("/profile/complete")
    }
  }, [
    isSessionValid,
    sessionUser,
    isEchoesConsentRequired,
    isProfileComplete,
    location.pathname,
    navigate,
  ])

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2 items-center justify-center min-h-screen">
        <Spinner className={"text-slate-600 size-6 transition-opacity"} />
        <div className="text-sm text-gray-500">Loading...</div>
      </div>
    )
  }

  if (!isSessionValid || !sessionUser) {
    toast.error("ユーザー情報の取得に失敗しました。ログインしてください。", {
      id: "session-error",
    })
    const redirectPath = location.pathname + location.search
    navigate(`/signin?redirect=${encodeURIComponent(redirectPath)}`)
    return null
  }

  return (
    <>
      <div className="bg-slate-50 mb-[70px]">
        <main className=" min-h-[calc(100vh-70px)] md:mx-auto md:max-w-md px-6 py-10">
          <Outlet />
        </main>
      </div>
      <GlobalNav />
    </>
  )
}
